export default {
  methods: {
    async logging(type, contents) {
      const deviceGroup = await this._loggingGetDeviceGroup();

      if (contents?.monthlyReport?.allDevices === true) {
        contents.monthlyReport.allDevices = deviceGroup;
      }

      // 出力ログの保存
      await this.azureRequest('/api/addLogs', 'POST', {
        type,
        userId: this.user_info.userId,
        deviceGroup: deviceGroup,
        contents,
      });
    },

    async _loggingGetDeviceGroup() {
      // デバイスグループを取得
      const deviceGroups = await this.apiRequest('/v1/master-info/userDeviceGroupAuthorities', 'GET', {
        device_group_id: this.user_info.deviceGroupId,
      });

      return {
        device_group_name_locale1: deviceGroups[0].device_group_name_locale1,
        device_group_name_locale2: deviceGroups[0].device_group_name_locale2,
        device_group_name_locale3: deviceGroups[0].device_group_name_locale3,
      };
    },
  },
};
